import { ReportsGridContainer } from './ReportsGrid'
import { PageTitle } from 'components/common/PageTitle'

const Lists = () => {
  return (
    <>
      <PageTitle view="Lists" />
      <div style={{ marginTop: '50px', height: 'calc(100% - 50px)' }}>
        <ReportsGridContainer />
      </div>
    </>
  )
}

export default Lists
